<!-- 快递转寄 -->
<template>
  <div class="expressForward cus-modal">
    <OmsForm :form-config="formConfigForInfo" class="title" />
    <OmsForm :form-config="formConfig" />
    <Divider orientation="center">{{ t('原地址信息') }}</Divider>
    <OmsForm :form-config="formConfig1" />
    <Divider orientation="center">{{ t('转寄地址') }}</Divider>
    <OmsForm :form-config="formConfig2" ref="form2" />
    <OmsButton :btn-config="btnConfig" class="modal-footer" />
  </div>
</template>
<script>
export default {
  props: {
    componentData: {
      type: Object,
      // default: () => {},
      default: {},
    },
  },
  data() {
    return {
      formConfigForInfo: {
        formValue: {
          BILL_NO: '',
          TID: '',
          CP_C_LOGISTICS_ENAME: '',
          EXPRESSCODE: ''
        },
        formData: [
          {
            style: 'span',
            label: t('订单编号'),
            value: 'BILL_NO',
            width: '6',
          },
          {
            style: 'span',
            label: t('平台单号'),
            value: 'TID',
            width: '6',
          },
          {
            style: 'span',
            label: t('物流公司'),
            value: 'CP_C_LOGISTICS_ENAME',
            width: '6',
          },
          {
            style: 'span',
            label: t('物流单号'),
            value: 'EXPRESSCODE',
            width: '6',
          },
        ]
      },
      formConfig: {
        formValue: {
          ST_C_REASON_FILE_ID: '1',
          ST_C_REASON_FILE_ECODE: '',
          ST_C_REASON_FILE_ENAME: '',
          FORWARD_FLAG: '',
          FORWARD_FEE: ''
        },
        formData: [
          {
            style: 'select',
            label: t('拦截原因'),
            value: 'ST_C_REASON_FILE_ID',
            width: '8',
            options: [{ label: t('用户修改地址'), value: '1' }],
          },
          {
            style: 'checkbox',
            label: t('是否转寄费到付'),
            value: 'FORWARD_FLAG',
            width: '4',
            labelWidth: 125,
          },
          {
            style: 'input',
            label: t('到付费用'),
            value: 'FORWARD_FEE',
            regx: /^\d*\.{0,1}\d{0,2}$/,
            width: '8',
          },
        ]
      },
      formConfig1: {
        formValue: {
          RECEIVER_NAME: '',
          RECEIVER_MOBILE: '',
          RECEIVER_PHONE: '',
          CP_C_REGION_PROVINCE_ENAME: '',
          CP_C_REGION_CITY_ENAME: '',
          CP_C_REGION_AREA_ENAME: '',
          CP_C_REGION_TOWN_ENAME: '',
          RECEIVER_ADDRESS: ''
        },
        formData: [
          {
            style: 'input',
            label: t('收件人'),
            value: 'RECEIVER_NAME',
            width: '8',
            disabled: true
          },
          {
            style: 'input',
            label: t('手机号'),
            value: 'RECEIVER_MOBILE',
            width: '8',
            disabled: true
          },
          {
            style: 'input',
            label: t('电话'),
            value: 'RECEIVER_PHONE',
            width: '8',
            disabled: true
          },
          {
            style: 'input',
            label: t('省'),
            value: 'CP_C_REGION_PROVINCE_ENAME',
            width: '8',
            disabled: true
          },
          {
            style: 'input',
            label: t('市'),
            value: 'CP_C_REGION_CITY_ENAME',
            width: '8',
            disabled: true
          },
          {
            style: 'input',
            label: t('区'),
            value: 'CP_C_REGION_AREA_ENAME',
            width: '8',
            disabled: true
          },
          {
            style: 'input',
            label: t('镇'),
            value: 'CP_C_REGION_TOWN_ENAME',
            width: '8',
            disabled: true
          },
          {
            style: 'input',
            label: t('详细地址'),
            value: 'RECEIVER_ADDRESS',
            width: '8',
            disabled: true
          },
        ]
      },
      formConfig2: {
        formValue: {
          RECEIVER_NAME: '',
          RECEIVER_MOBILE: '',
          RECEIVER_PHONE: '',
          CP_C_REGION_PROVINCE_ID: '',
          CP_C_REGION_PROVINCE_ECODE: '',
          CP_C_REGION_PROVINCE_ENAME: '',
          CP_C_REGION_CITY_ID: '',
          CP_C_REGION_CITY_ECODE: '',
          CP_C_REGION_CITY_ENAME: '',
          CP_C_REGION_AREA_ID: '',
          CP_C_REGION_AREA_ECODE: '',
          CP_C_REGION_AREA_ENAME: '',
          CP_C_REGION_TOWN_ENAME: '',
          RECEIVER_ADDRESS: ''
        },
        formData: [
          {
            style: 'input',
            label: t('收件人'),
            value: 'RECEIVER_NAME',
            width: '8',
          },
          {
            style: 'input',
            label: t('手机号'),
            value: 'RECEIVER_MOBILE',
            width: '8',
          },
          {
            style: 'input',
            label: t('电话'),
            value: 'RECEIVER_PHONE',
            width: '8',
          },
          {
            style: 'dropSelect',
            width: '8',
            value: 'CP_C_REGION_PROVINCE_ID',
            itemdata: {
              colid: 167814,
              colname: 'CP_C_REGION_PROVINCE_ID', // 当前字段的名称
              fkdisplay: 'drp', // 外键关联类型
              inputname: 'CP_C_STORE_IDS:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: true, // 是否必填
              isBackRowItem: true,
              name: t('省'), // 收货人省份 // input前面显示的lable值
              readonly: false, // 是否可编辑，对应input   readonly属性
              pid: '',
              valuedata: '', // 这个是选择的值
            },
            oneObj: e => {
              // 点击选中事件
              const { ID, ECODE, ENAME } = e.rowItem || {};
              this.formConfig2.formValue.CP_C_REGION_PROVINCE_ID = ID ? ID.val : '';
              this.formConfig2.formValue.CP_C_REGION_PROVINCE_ECODE = ECODE ? ECODE.val : '';
              this.formConfig2.formValue.CP_C_REGION_PROVINCE_ENAME = ENAME ? ENAME.val : '';
              // 联动清空
              this.formConfig2.formValue.CP_C_REGION_CITY_ID = '';
              this.formConfig2.formValue.CP_C_REGION_CITY_ECODE = '';
              this.formConfig2.formValue.CP_C_REGION_CITY_ENAME = '';
              this.formConfig2.formValue.CP_C_REGION_AREA_ID = '';
              this.formConfig2.formValue.CP_C_REGION_AREA_ECODE = '';
              this.formConfig2.formValue.CP_C_REGION_AREA_ENAME = ''
            },
          },
          {
            style: 'dropSelect',
            width: '8',
            value: 'CP_C_REGION_CITY_ID',
            itemdata: {
              colid: 167815,
              colname: 'CP_C_REGION_CITY_ID', // 当前字段的名称
              fkdisplay: 'drp', // 外键关联类型
              inputname: 'RECEIVER_CITY:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: true, // 是否必填
              isBackRowItem: true,
              name: t('市'), // 收货人市 // input前面显示的lable值
              readonly: false, // 是否可编辑，对应input   readonly属性
              pid: '',
              valuedata: '', // 这个是选择的值
              refcolval: {
                fixcolumn: 'C_UP_ID',
                expre: 'equal',
                srccol: 'CP_C_REGION_PROVINCE_ID',
              },
            },
            oneObj: e => {
              const { ID, ECODE, ENAME } = e.rowItem || {};
              this.formConfig2.formValue.CP_C_REGION_CITY_ID = ID ? ID.val : '';
              this.formConfig2.formValue.CP_C_REGION_CITY_ECODE = ECODE ? ECODE.val : '';
              this.formConfig2.formValue.CP_C_REGION_CITY_ENAME = ENAME ? ENAME.val : '';
              // 联动清空
              this.formConfig2.formValue.CP_C_REGION_AREA_ID = '';
              this.formConfig2.formValue.CP_C_REGION_AREA_ECODE = '';
              this.formConfig2.formValue.CP_C_REGION_AREA_ENAME = '';
            },
          },
          {
            style: 'dropSelect',
            width: '8',
            value: 'CP_C_REGION_AREA_ID',
            itemdata: {
              colid: 167816,
              colname: 'CP_C_REGION_AREA_ID', // 当前字段的名称
              fkdisplay: 'drp', // 外键关联类型
              inputname: 'RECEIVER_AREA:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: true, // 是否必填
              isBackRowItem: true,
              name: t('区'), // 收货人区 input前面显示的lable值
              readonly: false, // 是否可编辑，对应input   readonly属性
              pid: '',
              valuedata: '', // 这个是选择的值
              refcolval: {
                fixcolumn: 'C_UP_ID',
                expre: 'equal',
                srccol: 'CP_C_REGION_CITY_ID',
              }, // 过滤配置
            },
            oneObj: e => {
              const { ID, ECODE, ENAME } = e.rowItem || {};
              this.formConfig2.formValue.CP_C_REGION_AREA_ID = ID ? ID.val : '';
              this.formConfig2.formValue.CP_C_REGION_AREA_ECODE = ECODE ? ECODE.val : '';
              this.formConfig2.formValue.CP_C_REGION_AREA_ENAME = ENAME ? ENAME.val : '';
            },
          },
          {
            style: 'input',
            label: t('镇'),
            value: 'CP_C_REGION_TOWN_ENAME',
            width: '8',
          },
          {
            style: 'input',
            label: t('详细地址'),
            value: 'RECEIVER_ADDRESS',
            width: '8',
          },
        ],
        ruleValidate: {
          RECEIVER_NAME: [{ required: true, message: t('收件人') + t('不能为空!'), trigger: 'blur'  }],
          RECEIVER_MOBILE: [{ required: true, message: t('手机号') + t('不能为空!'), trigger: 'blur'  }],
          // RECEIVER_PHONE: [{ required: true, message: t('电话') + t('不能为空!'), trigger: 'blur'  }],
          CP_C_REGION_PROVINCE_ID: [{ required: true, message: t('省') + t('不能为空!'), trigger: 'blur'  }],
          CP_C_REGION_CITY_ID: [{ required: true, message: t('市') + t('不能为空!'), trigger: 'blur'  }],
          CP_C_REGION_AREA_ID: [{ required: true, message: t('区') + t('不能为空!'), trigger: 'blur'  }],
          RECEIVER_ADDRESS: [{ required: true, message: t('详细地址') + t('不能为空!'), trigger: 'blur'  }],
        }
      },
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            type: 'primary',
            text: t('确定'),
            loading: false,
            btnclick: () => {
              this.save();
            },
          },
        ],
      },
    }
  },
  watch: {
    'componentData.id': {
      handler(n, o) {
        this.init();
      },
      immediate: true
    },
  },
  methods: {
    valid() {
      // 主表校验
      const mainValid = () => {
        let valid = false
        for (let i of this.formConfig2.formData) {
          let rule = this.formConfig2.ruleValidate[i.value]
          if (rule && rule[0].required && !this.formConfig2.formValue[i.value]) {
            valid = true
            $fcError(rule[0].message)
            break;
          }
        }
        return valid
      }
      if (mainValid()) return false
      return true
    },
    save() {
      const params = {
        ID: this.componentData.row.ID,
        ...this.formConfig.formValue,
        ...this.formConfig2.formValue,
        FORWARD_FLAG: Number(this.formConfig.formValue.FORWARD_FLAG)
      }
      if (!this.valid()) return
      this.service.common.publicUrlParams('/api/cs/oc/oms/v1/express/intercept/forward', params).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message);
          this.$parent.$parent.closeConfirm();
          this.$parent.$parent.$parent.getData();
          this.$parent.$parent.$parent.selection = [];
        }
      })
    },
    init() {
      this.service.common.publicUrlParams('/api/cs/oc/oms/v1/express/intercept/forward/query', { ID: this.componentData.row.ID }).then(res => {
        if (res.data.code == 0) {
          // this.reasonList = res.data.data.stCReasonFileResults.map(i => {
          //   return { label: i.ST_C_REASON_FILE_ENAME, value: i.ST_C_REASON_FILE_ID, code: i.ST_C_REASON_FILE_ECODE }
          // })
          // $utils.queryForm(this.formConfig, 'ST_C_REASON_FILE_ID').options = this.reasonList
          // this.formConfig.formValue.ST_C_REASON_FILE_ID = this.reasonList[0].value
          const data = res.data.data
          delete data.stCReasonFileResults
          $utils.intersectFormValue(this.formConfigForInfo.formValue, data)
          $utils.intersectFormValue(this.formConfig.formValue, data)
          $utils.intersectFormValue(this.formConfig1.formValue, data)
          $utils.intersectFormValue(this.formConfig2.formValue, data)

          const FILED_CONFIG = [
            {
              CP_C_REGION_PROVINCE_ID: { pid: data.CP_C_REGION_PROVINCE_ID, valuedata: data.CP_C_REGION_PROVINCE_ENAME },
              CP_C_REGION_CITY_ID: { pid: data.CP_C_REGION_CITY_ID, valuedata: data.CP_C_REGION_CITY_ENAME },
              CP_C_REGION_AREA_ID: { pid: data.CP_C_REGION_AREA_ID, valuedata: data.CP_C_REGION_AREA_ENAME },
            }
          ]
          $utils.assignForm(this.formConfig2, data, FILED_CONFIG);
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .business-form-main.title {
  .ark-form-item {
    label {
      font-weight: 500;
      color: #17233d;
      font-size: 14px;
    }
  }
}
</style>